import { Chip, Divider, Stack, Typography, styled } from "@mui/material";
import { CalenderIcon } from "components/navigation/bottomNavigation/CustomIcon";
import { ItemTitleHead } from "components/typography/text";
import moment from 'moment-jalaali';
import { useNavigate } from "react-router-dom";
import { useContextState } from "services/context/MainContext";
import { urlChatPage } from "services/utils/globalVariables";

const TicketCardContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        background: white;
        padding: ${theme.spacing(2)};
        padding-bottom: ${theme.spacing(1)};
        border-radius: var(--border-radius);
        box-shadow: ${theme.shadows[3]};
        flex-direction: row;
    `
)

const TicketCardTimeContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    `
)

export default function TicketCard({ data }) {

    const { CreatedDate, Subject, Status, Id, UnreadMessages } = data

    const navigate = useNavigate()

    const handleNavigateDetail = () => {
        navigate(`${urlChatPage}/${Id}`)
    }

    return (
        <TicketCardContainer spacing={2} onClick={handleNavigateDetail}>
            <Stack spacing={2} sx={{width: "100%"}}>
                <Stack direction="row" justifyContent="space-between">
                    <ItemTitleHead noWrap>{Subject}</ItemTitleHead>
                    {UnreadMessages != 0 && <Chip size="small" sx={{color: "green"}} label={UnreadMessages} />}
                </Stack>
                <TicketCardTimeContainer>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <span style={{color: "var(--mc1)"}} ><CalenderIcon /></span>
                        <Typography sx={{color: "#656565"}}> {moment(CreatedDate).format("jYYYY/jMM/jDD")} </Typography>
                        <Divider orientation="vertical" />
                        <Typography sx={{color: "#656565"}}> {moment(CreatedDate).format("HH:mm")} </Typography>
                    </Stack>
                    {
                        Status == 0 && <Typography sx={{color: "#F44336"}} variant="body2">پاسخ داده نشده</Typography>
                    }
                    {
                        Status == 1 && <Typography sx={{color: "#66BB6A"}} variant="body2">پاسخ داده شده</Typography>
                    }
                </TicketCardTimeContainer>
            </Stack>
        </TicketCardContainer>
    )
}